import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const Catalogue = () => {
  const [catalogueData, setCatalogueData] = useState([]);
  const [loading, setLoading] = useState(true);
  const getCatalogue = () => {
    axios.post(API_URL.CATALOGUE_LIST, { is_seller: [0, 1] }).then(
      (res) => {
        if (res.data.status === 1) {
          setCatalogueData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-right",
        });
      }
    );
  };

  const deleteCatalogue = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CATALOGUE_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = catalogueData.filter((r) => r.id != row.id);
              setCatalogueData(newData);
            }
            toast.success(row.name + " Delete Successfully", {
              autoClose: 3000,
              position: "top-right",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  useEffect(() => {
    getCatalogue();
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <div className="d-flex align-items-center">
            <h5 className="me-1">Catalogue</h5>
            <small className="me-2">({catalogueData.length})</small>
          </div>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link
                  to={"/admin/catalogue/add"}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                  Catalogue
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "5%" }}>#</th>
                        <th style={{ width: "20%" }}>Cover Photo</th>
                        <th style={{ width: "25%" }}>Name</th>
                        <th style={{ width: "15%" }}>Size</th>
                        <th style={{ width: "20%" }}>Pdf Url</th>
                        <th style={{ width: "10%" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {catalogueData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td className="table-avatar">
                              <div
                                style={{
                                  backgroundImage: "url(" + row.image_url + ")",
                                  backgroundSize: "cover",
                                  height: 80,
                                  width: 150,
                                }}
                              ></div>
                            </td>
                            <td>
                              {row.name}
                            </td>
                            <td>
                              {row.size_name}
                            </td>
                            <td>
                              <a href={row.pdf_url} target="_blank" alt=""> {row.pdf}</a>
                            </td>
                            <td className="d-flex justify-content-end gap-3">
                              <Link
                                to={"/admin/catalogue/edit/" + row.id}
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                              <i onClick={() => deleteCatalogue(row)} className="fa fa-trash-alt"></i>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Catalogue;
